
import 'moment/locale/ar'
import LibCatergorySetting from "./components/LibCatergorySetting";
import SettingAdditions from './components/SettingAdditions';

export function OtherSettings() {

    return (
        <div className="container my-3 rounded bg-light-gray position-relative p-3 pb-5">
            <div className="accordion accordion-flush" id="accordionMasar">
                <div className="accordion-item">
                    <h6 className="accordion-header" id="headOne">
                        <button className="accordion-button collapsed bg-med-gray" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            إعدادات تصنيفات الكتب
                        </button>
                    </h6>
                    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="headOne" data-bs-parent="#accordionMasar">
                        <div className="accordion-body container">
                            <LibCatergorySetting />
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h6 className="accordion-header" id="headTwo">
                        <button className="accordion-button collapsed bg-med-gray" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            إضافة إعدادات
                        </button>
                    </h6>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="headTwo" data-bs-parent="#accordionMasar">
                        <div className="accordion-body container px-3">
                            <SettingAdditions />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}